import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Reveal } from "./Reveal";

const FAQS = [
  {
    q: "What does frantiger labs cost our institution?",
    a: "Zero setup friction. We co-design the engagement model with your management — from fully sponsored labs to revenue-share models on successful ventures. The first Vibe Check call is free, always.",
  },
  {
    q: "Does frantiger labs take equity in student startups?",
    a: "Models vary by campus. In most setups, equity (if any) is minimal, transparent and agreed upfront with the institution — never a surprise clause buried in a form.",
  },
  {
    q: "How does this help with NAAC / NIRF accreditation?",
    a: "An active incubation cell directly strengthens innovation and entrepreneurship scores under NIRF and supports NAAC criteria on research, innovation and extension. We help document and report it properly.",
  },
  {
    q: "How involved does our faculty need to be?",
    a: "As much or as little as you choose. frantiger consultants run the programming end-to-end; faculty champions typically spend 2–4 hours a week and often tell us it's the most fun part of their job.",
  },
  {
    q: "Which students are eligible?",
    a: "Any enrolled student with the itch to build — any stream, any year. No business background required. We select on intent and coachability, not on pedigree.",
  },
  {
    q: "How fast can a lab go live on our campus?",
    a: "From the Vibe Check call to a functioning lab: typically 4–6 weeks, including space setup, student onboarding and the first ideation sprint.",
  },
];

const Faq = () => (
  <section id="faq" className="blueprint-grid bg-[#F8FAFC] py-24 lg:py-32">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center">
        <span className="font-mono-x text-xs uppercase tracking-[0.25em] text-[#0055FF]">/ FAQ MATRIX</span>
        <h2 className="mt-5 font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl text-[#0A0D14] leading-tight">
          Everything you were <span className="font-serif-accent text-[#0055FF]">about to ask.</span>
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <div data-testid="faq-accordion-section" className="mt-12 border border-[#E2E8F0] bg-white">
          <Accordion type="single" collapsible>
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-b border-[#E2E8F0] last:border-b-0 px-6">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-5 text-left font-display font-semibold text-base sm:text-lg text-[#0A0D14] hover:text-[#0055FF] hover:no-underline"
                >
                  <span className="flex items-baseline gap-4">
                    <span className="font-mono-x text-xs text-[#0055FF]">{String(i + 1).padStart(2, "0")}</span>
                    {f.q}
                  </span>
                </AccordionTrigger>
                <AccordionContent data-testid={`faq-content-${i}`} className="pb-6 pl-9 text-sm text-[#64748B] leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Faq;
